<template>
  <div>
  <!--p class="fixed small bg-white left-0 top-20 z-50">
    progress:{{scrollProgress}}<br/>
     {{ headerClass }} m:{{ manualMenuToggle }}<br/>
     
    </p-->        
  <header @mouseout="timeOutToggle" @mousemove="handleMouseMove" :class="headerClass" class="fixed top-0 left-0 right-0 z-20">
    <div class="menubar relative w-full h-16 md:h-24 z-20">
      <UiContentwrapper class="items-center h-full">
        
        <!-- Left section: Menu Items -->
        <MenuLeftSection :mainMenu="mainMenu" @toggleDropdown="toggleDropdown" @toggleSearch="toggleSearch" :iconColor="iconColor" :currentMenu="currentMenu"/>

        <!-- Middle section: Centered Logo -->
        
        <MenuLogo @click="logoClick" class="cursor-pointer" :iconColor="iconColor" />
        

        <!-- Right section Desktop: Cart, Search & User Mobile Cart, Burger  -->
        <MenuRightSection :cartStore="cartStore" @toggleDropdown="toggleDropdown" @toggleSearch="toggleSearch" @toggleMobileMenu="toggleMobileMenu" :iconColor="iconColor"/>
      </UiContentwrapper>    
    </div>
    
    <!-- Full-width dropdown menu (positioned directly under the header) -->
    <div :class="{'open shadow-lg' : isDropdownOpen}" class="dropdownwrapper absolute top-0 left-0 w-full z-0 bg-white">
      
      <template v-if="mainMenu && mainMenu.items" v-for="(item, index) in mainMenu.items" :key="item.title">
          <transition name="fade-slide" mode="out-in"> 
            <template v-if="item.items && currentMenu === item.title">
              <MenuSubMenu class="submenu absolute top-0" :class="{'activesubmenu': currentMenu === item.title}" :menu="item" @closeDropdown="closeMenus" />
            </template>
          </transition>
          
      </template>
      
      <!-- Dropdown footer menu 'dropdown-footer' if exists-->
      <div v-if="footerMenu" class="w-full absolute bottom-10">
        <UiContentwrapper>
          <div class="col-span-10 flex">             
           <div v-for="(item, index) in footerMenu.items" :key="item.url" class="mr-10">            
              <NuxtLink :to="menuStore.stripDomain(item.url)" class="underline underline-offset-4 text-md">{{ item.title }}</NuxtLink>
            </div>
          </div>
        </UiContentwrapper>
      </div>
      <div v-else>        
            <!--p class="absolute bottom-20 left-20">missing menu 'dropdown-footer'</p-->  
      </div>
    </div>
  </header>

  <!-- Burger icon (conditionally rendered based on header visibility) desktop/mobile-->
  <transition name="fade-down"> 
    <button aria-label="Menu" @click="toggleHeader" class="hidden md:inline fixed top-4 right-4 z-50 " v-if="hiddenHeader">                 
     <IconMyburger/>
    </button>    
  </transition>
  <transition name="fade-down">     
    <button aria-label="Menu" @click="toggleHeaderMobile" class="md:hidden fixed top-4 right-4 z-50 " v-if="hiddenHeader">                 
     <IconMyburger/>
    </button>
  </transition>
  
  <!-- Mobile menu -->
  <transition name="slide-left">
    <MenuMobileMenu v-if="isMobileMenuOpen" :mainMenu="mainMenu" :footerMenu="footerMenu" />
  </transition>

  <transition name="slide-left">
    <SearchPanel v-if="searchOpen" @closeSearch="closeSearch"/>
  </transition>
</div>
</template>

<script setup>

import { useMenuStore } from "@/stores/menuStore";
import { useCartStore } from "@/stores/cartStore"; 
import { useEventListener } from '@vueuse/core';
import { searchOpen } from '@/composables/search';


const scrollprogress = ref(0);


const route = useRoute();

const currentMenu = ref('');
const isDropdownOpen = ref(false);
const isMobileMenuOpen = ref(false); 


const manualMenuToggle = ref(false);
const hiddenHeader = ref(false);


const menuStore = useMenuStore();
const cartStore = useCartStore();


const timeoutTimer = ref(null);

  // Hämta huvudmenyn
const { data: mainMenu, error: menuError } = await useAsyncData('main-menu', async () => {
  return await menuStore.fetchMenuByHandle('main-menu');
});

const { data: footerMenu, error: footerError } = await useAsyncData('dropdown-footer', async () => {
  return await menuStore.fetchMenuByHandle('dropdown-footer');
});


const toggleDropdown = (menu) => {
  
  if (currentMenu.value === menu && isDropdownOpen.value) {
    isDropdownOpen.value = false;
    
  } else {
    isDropdownOpen.value = true;
    currentMenu.value = menu;
  }
};

const closeSearch = () => {
  searchOpen.value = false;
};

const toggleSearch = () => {
  console.log('toggleSearch');
  closeMenus();
  currentMenu.value = '';
  searchOpen.value = !searchOpen.value;
};


const transparentMenu = computed(() => {
  let transparent = false;
  if(isIndexPage.value) {
    transparent = true;
  }

  if(searchOpen.value) {
    transparent = false;
  }

  if(manualMenuToggle.value) {
    transparent = false;
  }
  
  if(isDropdownOpen.value || isMobileMenuOpen.value) {
    transparent = false;
  }

  return transparent;
});


const headerClass = computed(() => {
  
  let classString = '';

  if(transparentMenu.value) {
    classString = 'transparentbg';
  } else {
    classString = 'whitebg';
  }

  if(isMobileMenuOpen.value) {
    classString += ' mobilemenu';
  }

  if(searchOpen.value) {
    classString += ' searchopen';
  }

  if (manualMenuToggle.value) {
    classString += ' visible manualtoggle';
        
  } else
  if (scrollprogress.value > 20 && !isMobileMenuOpen.value) {
    // Scrolling down: Hide header
    classString += ' hide';
    
  } else {
    // Scrolling to the top: Show the header again
    classString += ' show';
    
  }
  hiddenHeader.value = classString.includes('hide');
  return classString;
});



const isIndexPage = computed(() => {
  return route.path === '/';
});

const iconColor = computed(() => {
  return transparentMenu.value ? '#ffffff' : '#1C1C1C';
});

// Watch for route changes to close menus and reset header state
watch(
  () => route.path,
  () => {    
    handleScroll();
    closeMenus();
    closeSearch();
  }
);

// Handle scrolling
const handleScroll = () => {  
  scrollprogress.value = window.scrollY || 0;
};


// Toggle header visibility (via burger menu)
const toggleHeader = () => {
  manualMenuToggle.value = true;
  clearTimeout(timeoutTimer.value);
  timeoutTimer.value = setTimeout(() => {    
      manualMenuToggle.value = false;
  }, 3000);
};

const toggleHeaderMobile = () => {
  manualMenuToggle.value = true;
  isMobileMenuOpen.value = true;
  clearTimeout(timeoutTimer.value);
  timeoutTimer.value = setTimeout(() => {    
      manualMenuToggle.value = false;
  }, 3000);
};

const handleMouseMove = () => {
  clearTimeout(timeoutTimer.value);
  if(manualMenuToggle.value || isDropdownOpen.value) {
    toggleHeader();
  }
};

const timeOutToggle = () => {
  
  if(isMobileMenuOpen.value) {
    return;
  }
  clearTimeout(timeoutTimer.value);
  timeoutTimer.value = setTimeout(() => {    
      closeMenus();
  }, 1000);
};

const closeMenus = () => {  
  
  manualMenuToggle.value = false;
  toggleDropdown(currentMenu.value);
  currentMenu.value = '';
  isDropdownOpen.value = false; 
  isMobileMenuOpen.value = false;
  
};

const logoClick = () => {
  closeMenus();
  // Scroll to top if on index page
  if(isIndexPage.value ) {    
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }

};

// Toggle mobile menu visibility
const toggleMobileMenu = () => {
  console.log('toggleMobileMenu');
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

onMounted(async () => {
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);  
  if(!footerMenu.value){
    console.warn('No footer menu found');
  }

  useEventListener('keydown', (event) => {
        if (event.key === 'Escape') {            
              closeSearch();
              closeMenus();
        }
    })

});

onUnmounted(() => {
  // Cleanup scroll event listener
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>

header{
   
  transition: transform 0.5s ease, opacity 0.5s ease, background-color .5s ease, box-shadow .5s ease;
  
}
header.whitebg{
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  
}


header.whitebg.mobilemenu, header.whitebg.searchopen{
  box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0), 0 2px 4px -1px rgba(0, 0, 0, 0.0);
}


header .menubar{
  background-color: rgb(255, 255, 255);
  transition: background-color 0.5s ease;
}

header.transparentbg .menubar {
  background-color: rgba(255, 255, 255, 0);  
  
  
}

header.hide {
  opacity: 0;
  transition-delay: .3s;
  transform: translateY(-100%);

}


/* When the header is hidden */
.header-hidden {
  opacity: 0;
  transform: translateY(-100%);
}



/* Add underline on hover for mobile menu items */
button.hover\\:underline:hover {
  text-decoration: underline;
}

.dropdownwrapper {
  transition: transform 0.5s ease, height 0.5s ease;
  transform: translateY(-100%);
  display: inline-block;
  height: 750px;
  overflow: hidden;
  
}

.dropdownwrapper.open {
  transform: translateY(0%);  
  
}

.fade-slide-enter-from
{
  opacity: 0;
  transform: translateX(-5%);
  
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(5%);
  
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateX(0%), translateY(0%);
  
}

.fade-slide-enter-active{
  transition: opacity .5s ease-out , transform .3s ease-out;
}

.fade-slide-leave-active {
  transition: opacity .3s ease-out , transform .5s ease-out;
}

</style>